import { ApiProvider } from 'providers/request'
import {
  PredictiveModel,
  PredictiveModelCreateParams,
  PredictiveModelUpdateParams,
  PredictiveReportData,
} from 'models/predictive-model'
import { objectToFormData } from 'utils/object-to-formdata'

export const PredictiveModelRepository = {
  fetchAll(): Promise<PredictiveModel[]> {
    return ApiProvider.get('/predictive_models')
  },

  create(data: PredictiveModelCreateParams): Promise<PredictiveModel> {
    const formData = objectToFormData(data)
    return ApiProvider.post('/predictive_models', formData)
  },

  update(id: string, data: PredictiveModelUpdateParams): Promise<PredictiveModel> {
    const formData = objectToFormData(data)
    return ApiProvider.patch(`/predictive_models/${id}`, formData)
  },

  delete(id: string): Promise<void> {
    return ApiProvider.delete(`/predictive_models/${id}`)
  },

  generateReport(id: string): Promise<PredictiveReportData> {
    return ApiProvider.post(`/predictive_models/${id}/generate_report`)
  },
}
